import { StepType } from '../enums/step-type';
import { IEvent } from '@studyportals/event-aggregation-service-interface';
import { EventType } from '../enums/event-type';

export class JourneyStepChangedEvent implements IEvent {
	public static EventType: string = EventType.JOURNEY_STEP_CHANGED_EVENT;

	public readonly timestamp: Date;
	public readonly eventType = JourneyStepChangedEvent.EventType;

	constructor(public stepType: StepType) {
		this.timestamp = new Date();
	}
}
